var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full"},[_c('div',[_c('schedule-list',{attrs:{"reportData":_vm.reportData,"create":""},on:{"pushDataInReportTrigger":_vm.pushDataInReportTrigger}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }